export default {
  SET_DIALOG(state, value) {
    state.dialog = value;
  },
  SET_DIALOG_DATA(state, value) {
    state.item = value;
  },
};
